import { Button, Checkbox, FormControl, FormControlLabel, FormLabel, Grid, makeStyles, Radio, RadioGroup } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Feed from "../../components/feed";
import config from "../../config";
import { dispatch, eventListener, removeEventListener } from "../../events";
import { types } from "../../events/user";
import { types as loadTypes } from "../../events/loader";
import httpUtils from "../../utils/http.utils";

const useStyles = makeStyles((theme) => ({
    root: {
        overflow: 'overlay',
        height: 'calc(100vh - 64px)'
    },
    form: {
        margin: '15px',
        backgroundColor: 'white'
    }
}));

const Feeds = () => {
    const classes = useStyles();
    const [feeds, _setFeeds] = useState([]);
    const feedsRef = React.useRef(feeds);
    const setFeeds = data => {
        feedsRef.current = data;
        _setFeeds(data);
    };

    useEffect(() => {
        load({});
        eventListener(types.BLOCK_USER, onDeleteUser);
        localStorage.setItem('server', 'USA');
        return () => removeEventListener(types.BLOCK_USER, onDeleteUser)
    }, [])

    const onDeleteUser = (event) => {
        setFeeds(feedsRef.current.filter(f => f.user.id !== event.values.user.id));
    }

    const load = async ({ reset = false, reported = false }) => {
        dispatch(loadTypes.SET_LOADER);
        let updatedBefore = undefined;
        if (!reset && feedsRef.current.length > 0) {
            updatedBefore = feeds[feedsRef.current.length - 1].updatedAt
        }
        const results = (await httpUtils.get(`${config.BACK_API}/api/feed`,
            { updatedBefore, limit: 10, reported }
        )).data.results;

        let oldsFeeds = reset ? [] : feedsRef.current;
        setFeeds([...oldsFeeds, ...results.map(f => ({ ...f, reported }))]);
        dispatch(loadTypes.UNSET_LOADER);
    }

    const onDelete = (feed) => {
        setFeeds(feedsRef.current.filter(f => f.id !== feed.id));
    }

    const [server, setServer] = React.useState('USA');
    const handleServerChange = (event) => {
        setServer(event.target.value);
        localStorage.setItem('server', event.target.value);
        load({ reset: true, reported });
    };

    const [reported, setReported] = React.useState(false);
    const handleReportedChange = (event) => {
        setReported(event.target.checked);
        load({ reset: true, reported: event.target.checked });
    };

    return (
        <Grid container spacing={3} className={classes.root} >
            <Grid item xs={12} sm={12} className={classes.form}>
                <FormControl component="fieldset">
                    <FormLabel component="legend">Server</FormLabel>
                    <RadioGroup aria-label="gender" name="server" value={server} onChange={handleServerChange}>
                        <FormControlLabel value="USA" control={<Radio />} label="USA" />
                        <FormControlLabel value="EUROPE" control={<Radio />} label="EUROPE" />
                    </RadioGroup>
                </FormControl>
                <FormControlLabel control={<Checkbox value={reported} onChange={handleReportedChange} />} label="Reported" />
            </Grid>
            {feedsRef.current.map((feed) =>
                <Grid item xs={12} sm={4}>
                    <Feed feed={feed} onDelete={onDelete} />
                </Grid>
            )}
            <Grid item xs={12} sm={12}>
                <Button variant="contained" onClick={load}>Load more</Button>
            </Grid>
        </Grid >
    )

}

export default Feeds;